import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserInfo } from '../../datatypes/UserInfo';
import authApi from '../../api/auth.api';

type UserStateType = {
  isLoggedIn: boolean;
  users: UserInfo[];
  currentUser: UserInfo | null;
  tokenUser: UserInfo | null;
};

const initialState: UserStateType = {
  isLoggedIn: false,
  users: [],
  currentUser: null,
  tokenUser: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.isLoggedIn = true;
      state.currentUser = action.payload;
    },
    clearUser(state) {
      state.isLoggedIn = false;
      state.currentUser = null;
    },
    setUserByToken(state, action) {
      state.tokenUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserDetails.fulfilled, (state, action) => {
      state.currentUser = action.payload.user;
    });
  },
});

export const fetchUserDetails = createAsyncThunk(
  'user/fetchUserDetails',
  async () => {
    const response = await authApi().getAccountDetails();
    // The value we return becomes the `fulfilled` action payload
    return response;
  },
);

export const { setUser, clearUser, setUserByToken } = userSlice.actions;
export default userSlice.reducer;
